import React, { useEffect, useState } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { Button, Typography, Alert, Spin } from "antd";
import _consumerService from "../../../modules/consumerService";
const { Title } = Typography;

const ReportPreview = () => {
    const { docId } = useParams();
    const history = useHistory();
    const { state } = useLocation();
    const consumerId = state?.consumerId;

    const [loading, setLoading] = useState(false);
    const [doc, setDoc] = useState(null);

    useEffect(() => {
        getConsumerReportByConsumerId();
    }, [consumerId]);

    const getConsumerReportByConsumerId = async () => {
        try {
            setLoading(true);
            const res = await _consumerService.getConsumerReportByConsumerId(1);
            const docs = res?.data?.listApplicantDocs || [];

            const mappedDocs = docs.map((d, index) => ({
                id: String(index + 1),
                name: d.DocName,
                type: d.DocType?.replace(".", "").toUpperCase(),
                url: d.DocPath,
            }));

            const foundDoc = mappedDocs.find((d) => d.id === docId);
            setDoc(foundDoc || null);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Spin spinning={loading}>
            <div style={{ padding: 24, minHeight: "100vh" }}>

                <Button
                    style={{ marginBottom: "10px" }}
                    onClick={() => history.go(-1)}
                >
                    Back
                </Button>

                {doc ? (
                    <>
                        <Title level={4}>{doc.name}</Title>

                        {doc.type === "PDF" ? (
                            <iframe
                                src={`https://docs.google.com/gview?url=${encodeURIComponent(doc.url)}&embedded=true`}
                                title={doc.name}
                                style={{
                                    width: "100%",
                                    height: "80vh",
                                    border: "none",
                                }}
                            />
                        ) : doc.type === "XLSX" ? (

                            <div className="iframe-wrapper">
                                <iframe
                                    src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(doc.url)}&footer=false`}
                                    title={doc.name}
                                    className="excel-iframe"
                                />
                                <div className="iframe-footer-mask" />
                            </div>

                        ) : (
                            ""
                        )}
                    </>
                ) : (
                    ""
                )}
            </div>
        </Spin>
    );
};

export default ReportPreview;

